function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import SwiperSlider from 'integration-web-core--socle/js/assets/modules/_swiperSlider.class.js';
import Carousel from '@mozaic-ds/freemarker/js/modules/_carousel.js';
import contentLoader from 'integration-web-core--socle/js/assets/modules/_contentLoader';
var Subthematic = /*#__PURE__*/function (_lm$Composant) {
  /**
   * @constructor
   * @param {String} id
   */
  function Subthematic(id) {
    var _this;
    _classCallCheck(this, Subthematic);
    _this = _callSuper(this, Subthematic, [id]);

    // Init pagination display
    var paginationParam = new URL(document.location).searchParams.get("p");
    scrollInspirationListIntoView();
    initBrowserUrl();
    _this.swiper = document.querySelector('.m-carousel');
    var sliders = document.querySelectorAll('.o-products__linked-product-slider');
    sliders.forEach(function (slider) {
      new Carousel("#" + slider.id, {
        centerWhenNoButtons: true
      });
    });
    if (_this.swiper) {
      new SwiperSlider('.m-carousel');
      _resizeWindow.call(_this);
    }
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          if (mutation.addedNodes[0].tagName === 'IMG') {
            mutation.addedNodes[0].onload = function () {
              resizer(mutation.target.closest('.o-entry__wrapper'), mutation.target.closest('.js-list'));
            };
          } else {
            delay(function () {
              lm.lazyload.observe();
            }, 100);
          }
        }
      });
    });
    _toConsumableArray(document.querySelectorAll('.o-entry__global')).forEach(function (newImages) {
      observer.observe(newImages, {
        childList: true,
        attributes: true,
        subtree: true
      });
    });
    if (document.querySelector('.js-content-loader')) {
      contentDispatcher();
    }
    var resizeEvents = ['resize', 'orientationchange'];
    resizeEvents.forEach(function (event) {
      window.addEventListener(event, function () {
        _toConsumableArray(document.querySelectorAll('.js-list')).forEach(function (jsList) {
          delay(function () {
            resizeAll(jsList);
          }, 100);
        });
      });
    });
    var delay = function () {
      var timer = 0;
      return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    }();
    function resizer(item, parent) {
      var grid = parent;
      var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
      var rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
      var rowSpan = Math.ceil((item.querySelector('.o-entry__layout').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap) - 0.5);
      item.style.gridRowEnd = "span ".concat(rowSpan);
    }
    function resizeAll(parent) {
      var allItems = parent.querySelectorAll('.o-entry__wrapper');
      allItems.forEach(function (item) {
        resizer(item, parent);
      });
    }
    function _resizeWindow() {
      var _this2 = this;
      var scrollStop = function scrollStop(callback) {
        if (!callback || typeof callback !== 'function') return;
        var isResizing;
        window.addEventListener('resize', function () {
          window.clearTimeout(isResizing);
          isResizing = setTimeout(function () {
            callback();
          }, 66);
        }, false);
      };
      scrollStop.call(this, function () {
        _this2.swiper.querySelector('.kl-swiper').scrollBy(-10000000, 0);
      });
    }

    // Replace elements for loading
    function callback() {
      var showMore = document.querySelector('.js-show-more');
      var content = document.querySelector('.js-content-loader.lazy-loaded');

      // Remove last content loader informations element
      if (content && !showMore) content.remove();

      // Remove Button after first call
      if (showMore) showMore.remove();

      // Increment pagination and update url on hot-reload
      if (currentPage < maxPage) {
        currentPage++;
        window.history.replaceState("", "", "?p=" + currentPage);
      }
      lm.lazyload.observe();
    }
    function contentDispatcher() {
      var _this3 = this;
      // First action, click on see more
      document.querySelector('.js-content-loader').addEventListener('click', function (e) {
        e.preventDefault();
        new contentLoader(e.target, callback.bind(_this3));
      });

      // Event sent by lazyload.js
      document.addEventListener('contentLoading', function () {
        delay(function () {
          if (document.querySelector('span.js-content-loader')) {
            new contentLoader(document.querySelector('span.js-content-loader'), callback.bind(_this3));
          }
        }, 500);
      });
    }
    function scrollInspirationListIntoView() {
      if (paginationParam) {
        document.querySelector('.js-content-loader-container').scrollIntoView();
      }
    }
    function initBrowserUrl() {
      if (paginationParam) {
        window.history.replaceState("", "", "?p=" + currentPage);
      }
    }
    return _this;
  }
  _inherits(Subthematic, _lm$Composant);
  return _createClass(Subthematic);
}(lm.Composant);
lm.DOMReady(function () {
  new Subthematic('inspirationsubthematic');
});